import { render, staticRenderFns } from "./Lead.vue?vue&type=template&id=3d1ba4c8&scoped=true"
import script from "./Lead.vue?vue&type=script&lang=js"
export * from "./Lead.vue?vue&type=script&lang=js"
import style0 from "./Lead.vue?vue&type=style&index=0&id=3d1ba4c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1ba4c8",
  null
  
)

export default component.exports